import { FormEvent, useEffect, useState } from "react";
import { api } from "../api";
import { AdminShell } from "../components/admin/AdminShell";
import { Toast } from "../components/Toast";
import { useToast } from "../hooks/useToast";
import { PromoSettings } from "../types";

const defaultPromo: PromoSettings = {
  id: "public-promo",
  enabled: true,
  label: "Special sale",
  message: "Ажлын өдрүүдэд бүх багц 20% хямдралтай",
  accentText: "PicShot promotion",
  backgroundMode: "gradient",
  startColor: "#fff0f6",
  middleColor: "#ffe9b7",
  endColor: "#ff6f9f",
  textColor: "#001f3f",
  accentColor: "#9f1239",
  speedSeconds: 25,
};

export function PromoTickerPreview({ promo }: { promo: PromoSettings }) {
  const background =
    promo.backgroundMode === "solid"
      ? promo.startColor
      : `linear-gradient(90deg, ${promo.startColor} 0%, ${promo.middleColor} 45%, ${promo.endColor} 100%)`;

  return (
    <div className="promo-preview" style={{ background, color: promo.textColor }}>
      <div className="promo-preview-track" style={{ animationDuration: `${promo.speedSeconds}s` }}>
        {[0, 1, 2, 3].map((item) => (
          <span key={item}>
            <em style={{ color: promo.accentColor }}>{promo.label}</em>
            <strong>{promo.message}</strong>
            <em style={{ color: promo.accentColor }}>{promo.accentText}</em>
          </span>
        ))}
      </div>
    </div>
  );
}

export function AdminPromoPage() {
  const [promo, setPromo] = useState<PromoSettings>(defaultPromo);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const { toast, showToast } = useToast();

  useEffect(() => {
    api.getPromo()
      .then(setPromo)
      .finally(() => setLoading(false));
  }, []);

  async function savePromo(event: FormEvent) {
    event.preventDefault();
    setSaving(true);
    try {
      const saved = await api.updatePromo(promo);
      setPromo(saved);
      showToast("Promo хадгалагдлаа.");
    } finally {
      setSaving(false);
    }
  }

  function update<K extends keyof PromoSettings>(key: K, value: PromoSettings[K]) {
    setPromo((current) => ({ ...current, [key]: value }));
  }

  return (
    <AdminShell active="promo" title="Promo тохиргоо">
      <form className="admin-promo-card" onSubmit={savePromo}>
        <div>
          <h2>Public banner</h2>
          <p className="muted">User талын дээд хэсэгт урсдаг promo text-ийг эндээс удирдана.</p>
        </div>

        {loading ? (
          <p className="muted">Уншиж байна...</p>
        ) : (
          <>
            <PromoTickerPreview promo={promo} />

            <label className="toggle-line">
              <input type="checkbox" checked={promo.enabled} onChange={(event) => update("enabled", event.target.checked)} />
              Promo идэвхтэй
            </label>

            <div className="manual-grid">
              <label>
                Жижиг label
                <input value={promo.label} onChange={(event) => update("label", event.target.value)} />
              </label>
              <label>
                Гол текст
                <input value={promo.message} onChange={(event) => update("message", event.target.value)} />
              </label>
              <label>
                Accent текст
                <input value={promo.accentText} onChange={(event) => update("accentText", event.target.value)} />
              </label>
            </div>

            <div className="manual-grid compact">
              <label>
                Background төрөл
                <select value={promo.backgroundMode} onChange={(event) => update("backgroundMode", event.target.value as PromoSettings["backgroundMode"])}>
                  <option value="gradient">Gradient</option>
                  <option value="solid">Solid</option>
                </select>
              </label>
              <label>
                Урсах хурд /сек/
                <input
                  type="number"
                  min={8}
                  max={60}
                  value={promo.speedSeconds}
                  onChange={(event) => update("speedSeconds", Number(event.target.value))}
                />
              </label>
            </div>

            <div className="promo-color-grid">
              <label>
                Эхний өнгө
                <input type="color" value={promo.startColor} onChange={(event) => update("startColor", event.target.value)} />
              </label>
              <label>
                Дунд өнгө
                <input type="color" value={promo.middleColor} onChange={(event) => update("middleColor", event.target.value)} />
              </label>
              <label>
                Сүүлийн өнгө
                <input type="color" value={promo.endColor} onChange={(event) => update("endColor", event.target.value)} />
              </label>
              <label>
                Гол text
                <input type="color" value={promo.textColor} onChange={(event) => update("textColor", event.target.value)} />
              </label>
              <label>
                Accent text
                <input type="color" value={promo.accentColor} onChange={(event) => update("accentColor", event.target.value)} />
              </label>
            </div>

            <button className="primary-action" type="submit" disabled={saving}>
              {saving ? "Хадгалж байна..." : "Promo хадгалах"}
            </button>
          </>
        )}
      </form>
      <Toast message={toast} />
    </AdminShell>
  );
}
